<div class="site-shell">
  @if (showPreloader()) {
    <div class="articix-preloader" aria-live="polite" aria-label="Loading Articix website">
      <div class="preloader-content">
        <div class="logo-container">
          <div class="logo-glitch-wrapper">
            <img src="assets/logo/Articix-Transparent-BG.png" alt="Articix logo" class="preloader-logo" loading="eager">
          </div>
        </div>

        <div class="loading-stats">
          <div class="percentage-wrapper">
            <span class="percentage-number">{{ loadingProgress() }}</span>
            <span class="percentage-symbol">%</span>
          </div>
          <div class="loading-status">Engineering excellence...</div>
        </div>

        <div class="progress-bar-container">
          <div class="progress-bar-fill" [style.width.%]="loadingProgress()"></div>
        </div>
      </div>

      <div class="preloader-particles">
        @for (p of particles; track $index) {
          <div class="particle" [style.--i]="$index"></div>
        }
      </div>

      <div class="preloader-background">
        <div class="bg-grid"></div>
        <div class="bg-glow"></div>
      </div>
    </div>
  }

  @if (appState.hasError()) {
    <app-error500></app-error500>
  } @else if (maintenanceService.isMaintenanceEnabled()) {
    <app-maintenance></app-maintenance>
  } @else {
    @if (!isMaintenanceRoute()) {
      <app-header></app-header>
    }

    <main class="site-main" [class.app-home-active]="isHomeRoute() || isMaintenanceRoute()" appAnimateOnScroll [@routeAnimations]="getRouteAnimationData()">
      <router-outlet></router-outlet>
    </main>

    @if (!isMaintenanceRoute()) {
      <app-footer></app-footer>
    }

    @if (!isMaintenanceRoute()) {
      <app-cookie-consent></app-cookie-consent>
    }
  }
</div>
